import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { firestore } from "../Firebase/config";
import {
  doc,
  updateDoc,
  getDocs,
  where,
  collection,
  query,
} from "firebase/firestore";

const initialState = {
  dietId: "",
  dietList: [],
};

export const updateDiet = createAsyncThunk("updateDiet", async (payload) => {
  // console.log(payload);
  try {
    const docRef = await doc(firestore, "diet", payload.dietId);

    await updateDoc(docRef, {
      dietList: payload.dietList.questions,
    });

    return payload.dietList.questions;
  } catch (error) {
    // console.log(error);
  }
});

export const getDiet = createAsyncThunk("getDiet", async (userId) => {

  const getDietQuery = query(
    collection(firestore, "diet"),
    where("userId", "==", userId)
  );
  const res = await getDocs(getDietQuery);
  const diet = res.docs.map((doc) => doc);
  return { dietId: diet[0].id, dietList: diet[0].data() };
});

const DietSlice = createSlice({
  name: "diet",
  initialState,
  reducers: {
    defaultDietList: (state, action) => {
      state.dietId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateDiet.fulfilled, (state, action) => {
      // console.log(action.payload)
      state.dietList = action.payload;

    });

    builder.addCase(getDiet.fulfilled, (state, action) => {
      // console.log(action.payload)
      state.dietId = action.payload.dietId;
      state.dietList = action.payload.dietList.dietList;
    });
    builder.addCase(getDiet.rejected, (state, action) => {
      // console.log(action.error)
    })
  },
});

export default DietSlice.reducer;
export const { defaultDietList } = DietSlice.actions;
